import type { WheelEvent } from 'react';

// Spread onto the scrollable list container of any popover/dropdown that
// renders in a portal (Picker, Combobox, cmdk `CommandList`, custom popover
// lists).
//
// Why it's needed: when such a popover is opened from inside a Radix
// Dialog/Sheet, its content is portaled to `document.body` — outside the
// modal's `react-remove-scroll` subtree. That scroll-lock swallows wheel
// events anywhere outside its node, so the portaled list can't be scrolled by
// wheel/trackpad (keyboard arrows still work, which is why it reads as a
// "list won't scroll" bug rather than a layout one). Stopping the wheel event
// in the capture phase keeps it from reaching the lock, so the list scrolls.
//
// Harmless outside a modal: nothing relies on wheel events bubbling out of a
// dropdown list, so spreading this unconditionally is safe.
export const popoverScrollFix = {
  onWheelCapture: (e: WheelEvent) => e.stopPropagation(),
} as const;
